import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Picker, RelativeValue} from '../../interface/TimePicker';
import {RELATIVE_TYPE, TIME_PARTICLE_lIST} from '../../const/const';


@Component({
  selector: 'c-relative',
  templateUrl: './relative.component.html',
  styleUrls: ['./relative.component.css']
})
export class RelativeComponent implements OnInit {

  @Output() cChangeTime: EventEmitter<Picker> = new EventEmitter<Picker>();

  @Input() set cTime(value: RelativeValue) {
    if (!value) {
      return;
    }
    this.time = value;
  }

  public time: RelativeValue;

  public readonly relativeType = RELATIVE_TYPE;

  public readonly timeParticle = TIME_PARTICLE_lIST;

  constructor() {
  }

  ngOnInit() {
  }

  public selectChange() {
    const title = this.relativeType.find(item => item.key === this.time.abs).value + ' ' + this.time.step + ' ' +
      this.timeParticle.find(item => item.key === this.time.particle).value;
    this.cChangeTime.emit({
      title,
      value: this.time
    });
  }

}
